// extracted by mini-css-extract-plugin
export default {"container":"RIf1em","shadow":"sgg9Kt"};